import LoginForm from "../../components/LoginForm";
import "./../../css/Login.css"
import logo from "./../../images/logo.png";


const Login = () => {
    return (
        <main className="login text-white">
            <div className="login-content">
                <section className="login-text">
                    <h1 id="bienvenida" className="m-0">
                        Reserva <span className="bienvenida-highlight">fácil</span> e infórmate del estado y disponibilidad de cada equipo de nuestro: Centro de Operaciones y Logística <span className="bienvenida-highlight-green">(COL)</span> de Ecoturismo.
                    </h1>
                </section>
                <section className="login-form">
                    <LoginForm />
                </section>
            </div>
            <img
                className="login-logo"
                src={logo}
                alt="Logo"
            />
        </main>
    );
};
export default Login;